module.exports = __webpack_public_path__ + "static/media/Credit and Loans Services.5a1aba6b.png";